import { InMemoryCache } from 'apollo-cache-inmemory'
import ApolloClient from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import getCsrfToken from 'bits/csrf_token'
import VueApollo from 'vue-apollo'

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: '/api/graphql',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'X-UID': ww.uid,
    },
  }),
})

// Backward compatibility
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

export { apolloClient, apolloProvider }
